/**
 * Deep-link context helpers shared by the floating Delegate button, the contextual Create-task buttons,
 * and the task cards. The "where it came from" link is a same-origin RELATIVE path: pathname + ?tab=…
 * (see PackageDetail's useSearchParams tab sync, and spec/deep-links.md in task-board-pack).
 */
import type { Location } from 'react-router-dom';

/** The active tab/sub-view token for the current screen, read from the ?tab= query param (null if none). */
export function currentViewTab(loc: Pick<Location, 'search'>): string | null {
  return new URLSearchParams(loc.search).get('tab');
}

/** The canonical same-origin relative deep-link for the current screen (pathname + search). */
export function currentPageUrl(loc: Pick<Location, 'pathname' | 'search'>): string {
  return `${loc.pathname}${loc.search}`;
}

/** A short human label for the current route, used as the default task-context label. */
export function friendlyRouteLabel(loc: Pick<Location, 'pathname'>): string {
  const p = loc.pathname;
  if (p.startsWith('/packages/')) return '采购包 / Package';
  if (p.startsWith('/portal/engagements/')) return '投标 / Engagement';
  if (p === '/my-findings') return '整改 / Findings';
  if (p === '/tasks') return '任务 / Tasks';
  if (p === '/' ) return '工作台 / Dashboard';
  return p;
}
